import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]

import {ref} from "vue";
import {Api, gridActionFailure} from "@/shared/services/api";

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import {useVehicleRegistrationStore} from "@/modules/VehicleRegistration/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleRegistrationListComponent',
  emits: ["selected"],
  setup(__props, { expose: __expose, emit: __emit }) {

const _url = Api.baseUrl + '/VehicleRegistrationList';
const _adaptor = new CustomAdaptor()
const _grid = ref<InstanceType<typeof GridComponent> | null>(null)
const _vehicleStore = useVehicleRegistrationStore()
// Seitengröße und Seite aus dem Store (bleibt beim Wechsel zu den Details und nach dem Neuladen erhalten)
const _pageSettings = {
  pageSize: _vehicleStore.listPageSettings.pageSize,
  currentPage: _vehicleStore.listPageSettings.currentPage,
  pageSizes: ["All", 10, 25, 50, 100]
}

/* eslint-disable @typescript-eslint/no-explicit-any */
function onActionComplete(args: any) {
  if (args.requestType !== "paging") {
    return
  }
  // Seitenwechsel und geänderte Seitengröße melden beide "paging"
  const t_pageSettings = (_grid.value as any)?.ej2Instances?.pageSettings
  if (t_pageSettings?.currentPage) {
    _vehicleStore.listPageSettings.currentPage = t_pageSettings.currentPage
  }
  // "All" ergibt eine Seitengröße über 100; die wird nicht gemerkt
  if ([10, 25, 50, 100].includes(t_pageSettings?.pageSize)) {
    _vehicleStore.listPageSettings.pageSize = t_pageSettings.pageSize
  }
}


const _dataManager1 = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})


const _emit = __emit

function onRowSelected(args: any) {
  _emit("selected", args.data.id, args.data)
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _emit("selected", undefined)
}

function getFullName(field: string, data: any) {
  if (data['halterVorname'])
    return data['halterVorname'] + ' ' + data['halterNachname'];
  else
    return data['halterNachname'];
}

function getFullAddress(field: string, data: any,) {
  return data['halterStrasse'] + ' ' + data['halterHausnummer'] ?? "" + ' ' + data['halterPostleitzahl'] ?? "" + ' ' + data['halterWohnort'] + ' ' + data['halterStaat'];
}

/** Neu laden. Mit <c>resetPage</c> (Filter geändert) zurück auf Seite 1. */
function refresh(resetPage = false) {
  const t_pageSettings = (_grid.value as any)?.ej2Instances?.pageSettings
  if (resetPage && t_pageSettings && t_pageSettings.currentPage !== 1) {
    // Seitenwechsel lädt die Daten selbst
    t_pageSettings.currentPage = 1
    _vehicleStore.listPageSettings.currentPage = 1
    return
  }
  _grid.value?.refresh()
}

__expose({
  adaptor: _adaptor, refresh
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GridComponent), {
    id: "personList",
    ref_key: "_grid",
    ref: _grid,
    "data-source": _unref(_dataManager1),
    "allow-paging": true,
    "allow-sorting": true,
    width: "auto",
    "allow-reordering": true,
    "allow-resizing": true,
    "show-column-menu": false,
    "allow-text-wrap": true,
    "row-selected": onRowSelected,
    "row-deselected": onRowDeselected,
    "page-settings": _pageSettings,
    "action-complete": onActionComplete,
    "action-failure": _unref(gridActionFailure)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ColumnsDirective), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ColumnDirective), {
            "header-text": "",
            template: 'cTemplate',
            width: "70",
            "allow-sorting": false
          }, {
            cTemplate: _withCtx(({data}) => [
              _withDirectives(_createVNode(SogIcon, { icon: "mdi-car" }, null, 512), [
                [_vShow, data.insuranceId]
              ]),
              _withDirectives(_createElementVNode("span", {
                class: _normalizeClass(['confidence', 'confidence-' + data.suggestionConfidence]),
                title: data.suggestionText || 'Es gibt Verknüpfungsvorschläge'
              }, _toDisplayString(data.suggestionConfidence || '?'), 11, _hoisted_1), [
                [_vShow, data.hasSuggestion]
              ]),
              _withDirectives(_createVNode(SogIcon, {
                icon: "mdi-close",
                class: "cl"
              }, null, 512), [
                [_vShow, data.ignore==='Y']
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "insuranceNumber",
            "header-text": "VR.Nummer",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "evb",
            "header-text": "eVB/Form.Nr.",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "versicherungsScheinnummer",
            "header-text": "GDV-VSNr",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "versicherungsBestaetigungsNummer",
            "header-text": "GDV-VBNr",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "datumVersicherungsBeginn",
            "header-text": "VR-Beginn",
            "auto-fit": true,
            format: "dd.MM.yyyy",
            type: "dateTime"
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "fahrzeugIdentifizierungsNummer",
            "header-text": "Fahrzeug Id-Nummer",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "kennzeichen",
            "header-text": "Kennzeichnen",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "kennzeichenDatumGueltigBis",
            "header-text": "gueltig Bis",
            "auto-fit": true,
            format: "dd.MM.yyyy",
            type: "dateTime"
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "kennzeichenZeitpunktZuteilung",
            "header-text": "Zeitpunkt der Zuteilung",
            "auto-fit": true,
            format: "dd.MM.yyyy HH:mm:ss",
            type: "dateTime"
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "halterVorname",
            "header-text": "Halter",
            "auto-fit": true,
            "value-accessor": getFullName
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "halterStrasse",
            "header-text": "Halteranschrift",
            "auto-fit": true,
            "value-accessor": getFullAddress
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-source", "action-failure"]))
}
}

})